import React from 'react';
import { theme } from '../shared/config/theme';

export function formatUsdNano(value) {
  const amount = Number(value || 0) / 1_000_000_000;
  return `$${amount.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: amount > 0 && amount < 0.01 ? 6 : 4,
  })}`;
}

export function ProviderCostCell({ cost }) {
  if (!cost) return <span title="Данные расхода недоступны">—</span>;
  const incomplete = cost.unresolved_operations > 0;
  return (
    <div className="text-right leading-5" style={{ minWidth: 128 }}>
      <div className="font-semibold" title="Полученные от провайдера токены и учтённые вызовы по сохранённым тарифам. Резервы не включены.">
        {incomplete && !cost.measured_operations ? '—' : formatUsdNano(cost.cost_nano_usd)}
      </div>
      {incomplete && <div className="text-[11px] font-normal" style={{ color: theme.textSoft }}>
        Неполные данные · {cost.unresolved_operations} оп.
      </div>}
    </div>
  );
}

export function ProviderCostSummary({ cost, code = false }) {
  if (!cost) return null;
  return (
    <section aria-label={code ? 'Расходы Noesa Code' : 'Расходы всех продуктов'} className="my-5 rounded-2xl p-4"
      style={{ border: `1px solid ${theme.border}`, background: theme.bgSoft }}>
      <h3 className="text-base font-semibold" style={{ color: theme.text }}>
        {code ? 'Расходы Noesa Code' : 'Расходы всех продуктов'} · USD
      </h3>
      <div className="text-2xl font-semibold mt-2" style={{ color: theme.text }}>
        {cost.unresolved_operations > 0 && !cost.measured_operations ? '—' : formatUsdNano(cost.cost_nano_usd)}
      </div>
      <p className="text-xs leading-5 mt-2" style={{ color: theme.textSoft }}>
        {code ? 'Включено в общий расход. ' : 'Включая внутренние тестовые аккаунты. '}
        По полученным токенам и учтённым вызовам; резервы лимитов не включены. Период — по московскому времени.
        {!cost.invoice_reconciled && ' Итог ещё не сверен со счётом OpenAI; исторические пропуски могут не входить в сумму.'}
      </p>
      {cost.unresolved_operations > 0 && <p className="text-xs leading-5 mt-2" role="status" style={{ color: theme.text }}>
        Неполные данные: для {cost.unresolved_operations} операций нет подтверждённой стоимости. Сумма не является полным расходом за период.
      </p>}
    </section>
  );
}
